import React from 'react'

const removeSpinner = () =>
  document.body.classList.remove('vx_has-spinner', 'vx_has-spinner-large')

export const MailTo: React.FC<{ href: string; className: string }> = (
  props,
) => (
  <a
    onClick={removeSpinner}
    href={props.href ?? 'mailto:champions@paypal.com'}
    className={props.className ?? 'boxLink linkFormat'}
  >
    {props.children}
  </a>
)

export default MailTo
